import {downloadSampleImportVatTu, importDSVatTu} from "../phan-he-nhap-kho/services/services";
import {toast} from "react-toastify";
import {Button} from "react-bootstrap";
import {useContext} from "react";
import {AppContext} from "../appContext/AppContext";
import TextField from "./TextField";
import {CODE} from "../utils/Constant";
interface Props {
  warehouseId?: any;
  setLstItem?: (value: any) => void;
}
const BtnImport = (props: Props) => {
  const {setIsLoading} = useContext(AppContext);

  const handleSelectFileImport = async (e: any) => {
    if (!e.target.files[0]) return;
    try {
      setIsLoading(true);
      const file = e.target.files[0];
      const { data } = await importDSVatTu(file, props?.warehouseId);
      if (CODE.SUCCESS === data.code) {
        const newData = data.data.map((item: any) => ({
          ...item,
          warehouseId: props?.warehouseId,
        }));
        props?.setLstItem && props.setLstItem(newData);
      } else {
        toast.error(data?.message || "Có lỗi xảy ra, vui lòng thử lại");
      }
    } catch (error) {
      toast.error("Có lỗi xảy ra, vui lòng thử lại");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
      <Button className="btn btn-fill position-relative spaces min-w-90px ml-4" >
        Import danh sách
        <TextField
            className="btn-file"
            type="file"
            name="fileDSVatTuDuTru"
            onChange={(e: any) => handleSelectFileImport(e)}
        />
      </Button>
  );
};

export default BtnImport
